import React, { useState } from 'react'
import { Button, Dimmer, Icon, Input, Loader } from 'semantic-ui-react'
import { Image } from 'semantic-ui-react'
import { uploadFileToS3 } from '@iheartjane/react-image-list'
import { API_S3_UPLOAD } from '../../consts'
import LocaleSpecificSelect from '../Localizations/LocaleSpecificSelect/LocaleSpecificSelect'

interface OptionalLocalizedImageProps {
  isEditing: boolean
  onClick: () => void
  onChange: (x: string) => void
  inputName: string
  value: string | null
}

const OptionalLocalizedImage = (props: OptionalLocalizedImageProps) => {
  const { inputName, isEditing, onClick, onChange } = props

  const [loading, setLoading] = useState<boolean>(false)
  const [locale, setLocale] = useState<string>('US-AL')

  const uploadFile = async (file: File) => {
    return uploadFileToS3(API_S3_UPLOAD, file, {
      credentials: 'include',
    })
  }

  const img = () =>
    props.value
      ? JSON.parse(props.value.split('|')[1]).map((url: string, index: number) => (
          <Image
            id="batch-editor-new-upload-img"
            key={`${url}/${index}`}
            src={url}
            alt="Your new upload"
            rounded
            style={{ margin: '15px auto' }}
          />
        ))
      : null

  async function onFilesChange(e: any) {
    if (e.target?.files?.length) {
      setLoading(true)
      const promises: any[] = []
      for (let i = 0; i < e.target?.files?.length; i++) {
        const result = uploadFile(e.target.files[i])
        promises.push(result)
      }
      await Promise.all(promises)
        .then((urls) => {
          onChange(`${locale}|${JSON.stringify(urls)}`)
        })
        .catch((e) => console.error(e))
      setLoading(false)
    }
  }

  return (
    <div style={{ margin: '20px auto' }}>
      <Dimmer active={loading}>
        <Loader>Loading</Loader>
      </Dimmer>
      <Button
        color="teal"
        icon
        onClick={() => onClick()}
        size="huge"
        style={{
          marginRight: 50,
          opacity: isEditing ? '1' : '.5',
        }}
      >
        <Icon name={isEditing ? 'cancel' : 'pencil'} />
        {isEditing ? 'Cancel edit ' : `Set a ${inputName}`}
      </Button>
      {isEditing && (
        <>
          <div>
            <LocaleSpecificSelect value={locale} setValue={setLocale} />
          </div>

          <div>
            <Input
              disabled={!isEditing}
              id="bulk-editor-new-image-input"
              multiple
              onChange={(e) => onFilesChange(e)}
              size="massive"
              style={{
                marginTop: '30px',
              }}
              type="file"
            />
          </div>

          <div>
            <i>Use shift+click to select multiple images..</i>
            <br />
            <strong>Note: This replaces all of the images for the state that you select.</strong>
          </div>
          {img()}
        </>
      )}
    </div>
  )
}

export default OptionalLocalizedImage
